import { Component, input, output } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import {
  BadgeComponent,
  FormFieldComponent,
  GroupComponent,
  LabelComponent,
  RadioComponent,
} from '@core/user-interface-legacy';
import type { EvaluationSendAtKind } from '@recruitee/evaluations-types';

@Component({
  selector: 'rt-evaluation-send-at-kind-form-control',
  templateUrl: './evaluation-send-at-kind-form-control.component.html',
  styleUrl: './evaluation-send-at-kind-form-control.component.less',
  imports: [
    TranslatePipe,
    FormFieldComponent,
    LabelComponent,
    BadgeComponent,
    GroupComponent,
    RadioComponent,
  ],
})
export class EvaluationSendAtKindFormControlComponent {
  public readonly value = input<EvaluationSendAtKind | null>(null);
  public readonly isSchedulerLink = input<boolean>(false);

  public readonly valueChange = output<EvaluationSendAtKind>();
}
